import {
    DOWNLOAD_MANDATE_REPORT_ERROR,
    DOWNLOAD_MANDATE_REPORT_REQUEST,
    DOWNLOAD_MANDATE_REPORT_SUCCESS,
    FETCH_MANDATES_LIST_ERROR,
    FETCH_MANDATES_LIST_REQUEST,
    FETCH_MANDATES_LIST_SUCCESS,
    FETCH_MANDATE_TRANSACTION_LIST_ERROR,
    FETCH_MANDATE_TRANSACTION_LIST_REQUEST,
    FETCH_MANDATE_TRANSACTION_LIST_SUCCESS,
    GENERATE_MANDATE_REPORT_ERROR,
    GENERATE_MANDATE_REPORT_REQUEST,
    GENERATE_MANDATE_REPORT_SUCCESS,
    GET_ACTIVE_MANDATE_REPORT_ERROR,
    GET_ACTIVE_MANDATE_REPORT_REQUEST,
    GET_ACTIVE_MANDATE_REPORT_SUCCESS,
    HIDE_MANDATE_LOADER,
    RESET_MANDATE_TRANSACTION_LIST_DATA,
    SHOW_MANDATE_LOADER,
    UPDATE_MANDATE_STATUS_ERROR,
    UPDATE_MANDATE_STATUS_REQUEST,
    UPDATE_MANDATE_STATUS_SUCCESS,
} from './mandates.constant';

export const fetchMandatesRequest = payload => ({
    type: FETCH_MANDATES_LIST_REQUEST,
    payload,
});

export const fetchMandatesSuccess = payload => ({
    type: FETCH_MANDATES_LIST_SUCCESS,
    payload,
});

export const fetchMandatesError = payload => ({
    type: FETCH_MANDATES_LIST_ERROR,
    payload,
});

export const fetchMandatesTransactionListRequest = payload => ({
    type: FETCH_MANDATE_TRANSACTION_LIST_REQUEST,
    payload,
});

export const fetchMandatesTransactionListSuccess = payload => ({
    type: FETCH_MANDATE_TRANSACTION_LIST_SUCCESS,
    payload,
});

export const fetchMandatesTransactionListError = payload => ({
    type: FETCH_MANDATE_TRANSACTION_LIST_ERROR,
    payload,
});

export const updateMandateStatusRequest = payload => ({
    type: UPDATE_MANDATE_STATUS_REQUEST,
    payload,
});

export const updateMandateStatusSuccess = payload => ({
    type: UPDATE_MANDATE_STATUS_SUCCESS,
    payload,
});

export const updateMandateStatusError = payload => ({
    type: UPDATE_MANDATE_STATUS_ERROR,
    payload,
});

export const resetMandateTransactionList = payload => ({
    type: RESET_MANDATE_TRANSACTION_LIST_DATA,
    payload,
});

// REPORTING Actions
export const downloadMandateReportRequest = payload => ({
    type: DOWNLOAD_MANDATE_REPORT_REQUEST,
    payload,
});

export const downloadMandateReportSuccess = payload => ({
    type: DOWNLOAD_MANDATE_REPORT_SUCCESS,
    payload,
});

export const downloadMandateReportError = payload => ({
    type: DOWNLOAD_MANDATE_REPORT_ERROR,
    payload,
});

export const generateMandateReportRequest = payload => ({
    type: GENERATE_MANDATE_REPORT_REQUEST,
    payload,
});

export const generateMandateReportSuccess = payload => ({
    type: GENERATE_MANDATE_REPORT_SUCCESS,
    payload,
});

export const generateMandateReportError = payload => ({
    type: GENERATE_MANDATE_REPORT_ERROR,
    payload,
});

export const getActiveMandateReportRequest = hideLoader => ({
    type: GET_ACTIVE_MANDATE_REPORT_REQUEST,
    hideLoader,
});

export const getActiveMandateReportSuccess = payload => ({
    type: GET_ACTIVE_MANDATE_REPORT_SUCCESS,
    payload,
});

export const getActiveMandateReportError = payload => ({
    type: GET_ACTIVE_MANDATE_REPORT_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_MANDATE_LOADER });

export const hideLoader = () => ({ type: HIDE_MANDATE_LOADER });
